import { useState } from "react";
import { useCurrentUser } from "../hooks/useCurrentUser";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import "../assets/css/userSettings.css";
import "../assets/images/userSettings";
import { settingsIcons } from "../assets/images/userSettings";
import { logout } from "../lib/api"; // appelle /auth/logout/ + clear tokens

export default function UserSettings() {
  const [activeTab, setActiveTab] = useState("profile");
  const { user } = useCurrentUser();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout(); // backend + suppression des tokens
    } catch (e) {
      console.error("Erreur lors de la déconnexion :", e);
    } finally {
      navigate("/login", { replace: true });
    }
  };

  const handleGoToUserManagement = () => {
    navigate("/settings/users");
  };

  return (
    <div className="page-container">
      <Sidebar />

      <div className="content-container">
        <div className="container-fluid">
          <div className="userGreeting">
            <span className="typoBlackStar">
              Hello {user?.first_name || user?.username || ''},
            </span>
            <br />
            <span style={{ display: "none"}}>Lorem ipsum</span>
          </div>

          <div className="settings-container">
            {/* MENU GAUCHE */}
            <div className="settings-menu">
              <div className="menu-tabs">
                <button
                  className={`tab-links ${
                    activeTab === "profile" ? "link-active" : ""
                  }`}
                  onClick={() => setActiveTab("profile")}
                >
                  Mon profil
                </button>
                <button
                  style={{ display: "none" }}
                  className={`tab-links ${
                    activeTab === "preferences" ? "link-active" : ""
                  }`}
                  onClick={() => setActiveTab("preferences")}
                >
                  Préférences
                </button>
                <button
                  style={{ display: "none" }}
                  className={`tab-links ${
                    activeTab === "notifications" ? "link-active" : ""
                  }`}
                  onClick={() => setActiveTab("notifications")}
                >
                  Notifications
                </button>
                <button
                  className={`tab-links ${
                    activeTab === "conditions" ? "link-active" : ""
                  }`}
                  onClick={() => setActiveTab("conditions")}
                >
                  Conditions
                </button>
                <button
                  className={`tab-links ${
                    activeTab === "policy" ? "link-active" : ""
                  }`}
                  onClick={() => setActiveTab("policy")}
                >
                  Politique de confidentialité
                </button>
              </div>

              {/* BOUTONS EN BAS : Gestion utilisateurs + Logout */}
              <div className="menu-log">
                <button
                  className="delete"
                  // TODO : implémenter la suppression de compte plus tard
                  type="button"
                >
                  Supprimer le compte
                </button>

                {/* Bouton Gestion des utilisateurs → /settings/users */}
                <button
                  type="button"
                  className="log-out"
                  onClick={handleGoToUserManagement}
                >
                  <p>Gestion des utilisateurs</p>
                  <img src={settingsIcons.edit} alt="Gestion des utilisateurs" />
                </button>

                {/* Bouton Déconnexion */}
                <button
                  className="log-out"
                  type="button"
                  onClick={handleLogout}
                >
                  <p>Déconnexion</p>
                  <img src={settingsIcons.exit} alt="Déconnexion" />
                </button>

                <div className="menu-footer">© 2026 Polyglow</div>
              </div>
            </div>

            {/* CONTENU DROIT (tabs) */}
            <div className="settings-page">
              {activeTab === "profile" && (
                <div id="profile" className="tab-content tab-active">
                  <h3>Mon profil</h3>
                  <div className="user-profile">
                    <div className="profile-infos">
                      <img src={settingsIcons.profile} alt="Profil" />
                      <div className="profile-status">
                        <h4>{user?.first_name || user?.username || 'Utilisateur'}</h4>
                        <h5 className="status">User group</h5>
                        <p className="member">Membre depuis X jours</p>
                      </div>
                    </div>
                    <div className="btn-edit">
                      <button>
                        éditer
                        <img src={settingsIcons.edit} alt="Editer" />
                      </button>
                    </div>
                  </div>
                  <div className="user-personal-datas">
                    <h4>Informations personnelles</h4>
                    <div className="datas-section">
                      <div className="datas-items">
                        <div className="mail">
                          <h5>Adresse mail</h5>
                          <p>{user?.email || '-'}</p>
                        </div>
                        <div className="nickname">
                          <h5>Pseudo</h5>
                          <p>{user?.username || '-'}</p>
                        </div>
                        <div className="password">
                          <h5>Mot de passe</h5>
                          <p>User password (hidden)</p>
                        </div>
                      </div>
                      <div className="btn-edit">
                        <button>
                          éditer
                          <img src={settingsIcons.edit} alt="Editer" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "preferences" && (
                <div id="preferences" className="tab-content tab-active">
                  <h3>Mes préférences</h3>
                  <div className="sound-effects pref-item">
                    <div className="content">
                      <img src={settingsIcons.sound} alt="Effets sonores" />
                      <div className="text">
                        <h5>Effets sonores</h5>
                        <p>
                          Activer les effets sonores durant les parties de jeux
                        </p>
                      </div>
                    </div>
                    <label className="switch">
                      <input type="checkbox" />
                      <span className="slider"></span>
                    </label>
                  </div>
                  <div className="music pref-item">
                    <div className="content">
                      <img src={settingsIcons.sound} alt="Musique" />
                      <div className="text">
                        <h5>Musique</h5>
                        <p>Activer la musique durant les parties de jeux</p>
                      </div>
                    </div>
                    <label className="switch">
                      <input type="checkbox" />
                      <span className="slider"></span>
                    </label>
                  </div>
                </div>
              )}

              {activeTab === "notifications" && (
                <div id="notifications" className="tab-content tab-active">
                  <h3>Notifications</h3>
                  <div className="training-reminders">
                    <div className="content">
                      <img src={settingsIcons.training} alt="Rappels" />
                      <div className="text">
                        <h5>Rappels d’entrainement</h5>
                        <p>
                          Activer les notifications de rappels d’entrainement
                        </p>
                      </div>
                    </div>
                    <label className="switch">
                      <input type="checkbox" />
                      <span className="slider"></span>
                    </label>
                  </div>
                  <div className="new-features">
                    <div className="content">
                      <img src={settingsIcons.newF} alt="Nouvelles fonctionnalités" />
                      <div className="text">
                        <h5>Annonce nouvelles fonctionnalités</h5>
                        <p>
                          Activer les pop-up d’annonce de nouvelles
                          fonctionnalités
                        </p>
                      </div>
                    </div>
                    <label className="switch">
                      <input type="checkbox" />
                      <span className="slider"></span>
                    </label>
                  </div>
                </div>
              )}

              {activeTab === "conditions" && (
                <div id="conditions" className="tab-content tab-active">
                  <h3>Conditions d'utilisation</h3>
                  <div className="content">
                      <div className="mentions">
                          <h4>MENTIONS LEGALES</h4>
                          <p>polyglow.fr</p>
                          <h5>Éditeur</h5>
                          <p>polyglow.fr</p>
                          <p>Le site internet www.polyglow.fr est édité par :<br />
                          Raison sociale : XXXXX<br />
                          Forme juridique : XXXXX<br />
                          SIRET : XXXXXXXXX<br />
                          Siège social : 114 Rue Henri Dunant 92700 Colombes<br />
                          Téléphone : +33 (0)6 81 40 01 26<br />
                          Directeur de la publication : XXXXXXXXXXX<br />
                          Email : info@polyglow.fr</p>

                          <h5>Conception Web</h5>
                          <p>XXXX<br />
                          Siège social : XXXX<br />
                          Tél. : XXXXXXX<br />
                          Site web : XXXX : Création site web</p>

                          <h5>Hébergement web</h5>
                          <p>Raison sociale : XXXXX<br />
                          Siège social : XXXXXXXXXXXXXXXXXX</p>
                      </div>
                      <div className="conditions">
                          <h4>CONDITIONS GÉNÉRALES D’UTILISATION</h4>
                          <h5>I – Objet</h5>
                          <p>Les présentes Conditions Générales d’Utilisation ont pour objet l’encadrement juridique des
                          modalités d’utilisation du Site par « l’Utilisateur », défini comme toute personne accédant au Site et
                          l’utilisant.<br />
                          L’utilisation du site polyglow.fr implique l’acceptation pleine et entière des conditions générales
                          d’utilisation ci-après décrites ainsi que de la politique de confidentialité. Ces conditions d’utilisation
                          sont susceptibles d’être modifiées ou complétées à tout moment, les Utilisateurs du
                          site polyglow.fr sont donc invités à les consulter de manière régulière.</p>

                          <h5>2. Conditions générales d’utilisation du site et des services proposés</h5>
                          <p>Ce site est normalement accessible à tout moment aux Utilisateurs. Une interruption pour raison de
                          maintenance technique peut être toutefois décidée par France-Anne CHENU-TOURNIER, qui
                          s’efforcera alors de communiquer préalablement aux Utilisateurs les dates et heures de
                          l’intervention.<br />
                          Le site polyglow.fr est mis à jour régulièrement.<br />
                          De la même façon, les mentions légales peuvent être modifiées à tout moment : elles s’imposent
                          néanmoins à l’Utilisateur qui est invité à s’y référer le plus souvent possible afin d’en prendre
                          connaissance.</p>

                          <h5>3. Description des services fournis</h5>
                          <p>Le site polyglow.fr a pour objet de fournir une information concernant l’ensemble des activités de
                          la société.<br />
                          Le site polyglow.fr fournit des informations aussi précises que possible. Toutefois, France-Anne
                          Chenu-Tournier ne pourra être tenue responsable des omissions, des inexactitudes et des carences
                          dans la mise à jour, qu’elles soient de son fait ou du fait des tiers partenaires qui lui fournissent ces
                          informations.<br />
                          Toutes les informations indiquées sur le site polyglow.fr sont données à titre indicatif, et sont
                          susceptibles d’évoluer. Par ailleurs, les renseignements figurant sur le site polyglow.fr ne sont pas
                          exhaustifs. Ils sont donnés sous réserve de modifications ayant été apportées depuis leur mise en
                          ligne.</p>

                          <h5>4. Liens hypertextes et cookies</h5>
                          <p>Le site polyglow.fr peut proposer des liens depuis son site vers d&#39;autres sites partenaires ou non-
                          partenaires. Le site polyglow.fr contient un certain nombre de liens hypertextes vers d’autres sites,
                          mis en place avec l’autorisation de France-Anne CHENU-TOURNIER. Cependant, ces sites sont
                          indépendants, polyglow.fr n&#39;édite pas et ne contrôle pas ces sites. Les liens vers tous sites ne
                          constituent, en aucun cas, une approbation ou un partenariat entre polyglow.fr et ces sites. Dès
                          lors, polyglow.fr ne saurait être responsable de leurs contenus, leurs produits, leurs publicités ou
                          tous éléments ou services présentés sur ces sites.</p>

                          <h5>4. Liens hypertextes et cookies</h5>
                          <p>Le site polyglow.fr peut proposer des liens depuis son site vers d&#39;autres sites partenaires ou non-
                          partenaires. Le site polyglow.fr contient un certain nombre de liens hypertextes vers d’autres sites,
                          mis en place avec l’autorisation de France-Anne CHENU-TOURNIER. Cependant, ces sites sont
                          indépendants, polyglow.fr n&#39;édite pas et ne contrôle pas ces sites. Les liens vers tous sites ne
                          constituent, en aucun cas, une approbation ou un partenariat entre polyglow.fr et ces sites. Dès
                          lors, polyglow.fr ne saurait être responsable de leurs contenus, leurs produits, leurs publicités ou
                          tous éléments ou services présentés sur ces sites.<br />
                          La navigation sur le site polyglow.fr est susceptible de provoquer l’installation de cookie(s) sur
                          l’ordinateur de l’Utilisateur.</p>

                          <h5>Que sont les cookies ?</h5>
                          <p>Un cookie est une information déposée sur le disque dur d&#39;un internaute par le serveur du site qu&#39;il
                          visite. Il contient plusieurs données : le nom du serveur qui l&#39;a déposé, un identifiant sous forme de
                          numéro unique, éventuellement une date d&#39;expiration. Ces informations sont parfois stockées sur
                          l&#39;ordinateur dans un simple fichier texte auquel un serveur accède pour lire et enregistrer des
                          informations.</p>

                          <h5>A quoi servent les cookies ?</h5>
                          <p>Les cookies enregistrent des informations relatives à la navigation d’un ordinateur sur un site. Les
                          données ainsi obtenues visent à faciliter la navigation ultérieure sur le site, et ont également
                          vocation à permettre diverses mesures de fréquentation.<br />
                          Le refus d’installation d’un cookie peut entraîner l’impossibilité d’accéder à certains services.
                          L’utilisateur peut toutefois configurer son ordinateur de la manière suivante, pour refuser
                          l’installation des cookies :<br />
                          Sous Internet Explorer : onglet outil (pictogramme en forme de rouage en haut a droite) / options
                          internet. Cliquez sur Confidentialité et choisissez Bloquer tous les cookies. Validez sur Ok.
                          Sous Firefox : en haut de la fenêtre du navigateur, cliquez sur le bouton Firefox, puis allez dans
                          l’onglet Options. Cliquer sur l’onglet Vie privée.<br />
                          Paramétrez les Règles de conservation sur : utiliser les paramètres personnalisés pour l’historique.
                          Enfin décochez-la pour désactiver les cookies.<br />
                          Sous Safari : Cliquez en haut à droite du navigateur sur le pictogramme de menu (symbolisé par un
                          rouage). Sélectionnez Paramètres. Cliquez sur Afficher les paramètres avancés. Dans la section
                          « Confidentialité », cliquez sur Paramètres de contenu. Dans la section « Cookies », vous pouvez
                          bloquer les cookies.<br />
                          Sous Chrome : Cliquez en haut à droite du navigateur sur le pictogramme de menu. Sélectionnez
                          Paramètres. Dans la section « Confidentialité », vous pouvez bloquer les cookies.</p>

                          <h5>Propriété intellectuelle et contrefaçons</h5>
                          <p>L&#39;ensemble des éléments que vous voyez, que vous écoutez ou que vous lisez sur le site ainsi que le
                          site sont protégés par la législation relative aux droits d&#39;auteur ou à l&#39;image.<br />
                          Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des
                          éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite
                          préalable de : polyglow.fr.<br />
                          Toute exploitation non autorisée du site ou de l’un quelconque des éléments qu’il contient sera
                          considérée comme constitutive d’une contrefaçon et poursuivie conformément aux dispositions des
                          articles L.335-2 et suivants du Code de Propriété Intellectuelle.</p>

                          <h5>Obligations des Utilisateurs du site internet</h5>
                          <p>Les Utilisateurs s’engagent à utiliser le présent site internet dans les conditions suivantes :<br />
                          -ne pas utiliser le site aux fins d’entraver ou altérer son fonctionnement, notamment en
                          l’encombrant, volontairement ou involontairement, par le transfert intempestif de contenus, en
                          dehors des cas d’utilisation prévus;<br />
                          -ne pas extraire, copier, dupliquer, des éléments et graphismes du site internet, sur lesquels l’éditeur
                          dispose des droits de propriété intellectuelle;<br />
                          -ne pas introduire de fichiers/programmes malveillants, ou contenant des virus informatiques;<br />
                          -ne pas stocker, transmettre du contenu non autorisé, qui serait illégal ou qui pourrait être
                          constitutif d’incitation à la réalisation de crimes et délits, de diffamations et injures, d’atteinte à la
                          vie privée, ou encore d’actes mettant en péril des mineurs;<br />
                          -ne pas transmettre de contenu qui violerait le droit à l’image, tout droit de propriété intellectuelle
                          tout autre droit appartenant à autrui.</p>

                          <h5>Crédits images</h5>
                          <p>Les images de ce site tirées de banques d&#39;images libre de droit le restent pour toute utilisation.</p>

                          <h5>Limitations contractuelles sur les données techniques</h5>
                          <p>Le site Internet ne pourra être tenu responsable de dommages matériels liés à l’utilisation du site. De
                          plus, l’Utilisateur du site s’engage à accéder au site en utilisant un matériel récent, ne contenant pas
                          de virus et avec un navigateur de dernière génération mis-à-jour.</p>

                          <h5>Limitations de responsabilité</h5>
                          <p>L&#39;Utilisateur reconnaît avoir pris connaissance des présentes Mentions Légales et s&#39;engage à les
                          respecter.<br />
                          L&#39;Utilisateur du site internet polyglow.fr reconnaît disposer de la compétence et des moyens
                          nécessaires pour accéder et utiliser ce site. L’Utilisateur est seul responsable des choix qu’il fait.
                          Ainsi, la responsabilité de l’éditeur ne saurait être engagée en raison de l’inadaptation des services
                          du site internet aux besoins et informations exprimés par l’Utilisateur.<br />

                          L’éditeur n’est pas non plus responsable des conséquences dommageables liées au réseau de
                          communication et des défaillances d’accès à Internet et de sécurité informatique de l’Utilisateur.<br />

                          France-Anne CHENU-TOURNIER ne pourra être tenue responsable des dommages directs et indirects
                          causés au matériel de l’Utilisateur, lors de l’accès au site polyglow.fr, et résultant soit de
                          l’utilisation d’un matériel ne répondant pas aux spécifications indiquées au point 4, soit de
                          l’apparition d’un bug ou d’une incompatibilité.<br />
                          France-Anne CHENU-TOURNIER ne pourra également être tenue responsable des dommages
                          indirects (tels par exemple qu’une perte de marché ou perte d’une chance) consécutifs à l’utilisation
                          du site polyglow.fr.<br />
                          polyglow.fr met tout en œuvre pour offrir aux Utilisateurs des informations et/ou des outils
                          disponibles et vérifiés mais ne saurait être tenue pour responsable des erreurs, d&#39;une absence de
                          disponibilité des fonctionnalités et/ou de la présence de virus sur son site.<br />
                          Les informations fournies par polyglow.fr le sont à titre indicatif et ne sauraient dispenser
                          l&#39;Utilisateur d&#39;une analyse complémentaire et personnalisée.<br />
                          polyglow.fr ne saurait garantir l&#39;exactitude, la complétude, l&#39;actualité des informations diffusées
                          sur son site.<br />
                          En conséquence, l&#39;Utilisateur reconnaît utiliser ces informations sous sa responsabilité exclusive.<br />
                          Des espaces interactifs (possibilité de poser des questions dans l’espace contact) sont à la disposition
                          des Utilisateurs. France-Anne CHENU-TOURNIER se réserve le droit de supprimer, sans mise en
                          demeure préalable, tout contenu déposé dans cet espace qui contreviendrait à la législation
                          applicable en France, en particulier aux dispositions relatives à la protection des données. Le cas
                          échéant, France-Anne CHENU-TOURNIER se réserve également la possibilité de mettre en cause la
                          responsabilité civile et/ou pénale de l’Utilisateur, notamment en cas de message à caractère raciste,
                          injurieux, diffamant, ou pornographique, quel que soit le support utilisé (texte, photographie…).</p>
                      </div>
                  </div>
                </div>
              )}

              {activeTab === "policy" && (
                <div id="policy" className="tab-content tab-active">
                  <h3>Politique de confidentialité</h3>
                  <div className="content">
                    <div className="policy">
                      <h5>Dispositions générales</h5>
                      <p>En utilisant le Site, l’Utilisateur défini comme toute personne accédant au Site et l’utilisant, accepte
                      la collecte et l’utilisation de ses données, personnelles ou non, de la manière décrite dans la présente
                      Politique de Confidentialité.<br />
                      L’expression « informations personnelles » désigne « les informations qui permettent, sous quelque
                      forme que ce soit, directement ou non, l’identification des personnes physiques auxquelles elles
                      s’appliquent » (article 4 de la loi n° 78-17 du 6 janvier 1978).<br />
                      En cas de mise à jour/ modification de la Politique de Confidentialité, cette dernière sera mise en
                      ligne sur le Site avec mention de la dernière date de mise à jour.<br />
                      L’Utilisateur devra en conséquence vérifier régulièrement le Site pour rester informé de tout
                      changement ou mise à jour de la Politique de Confidentialité.</p>

                      <h5>Gestion des données personnelles.</h5>
                      <p>Conformément à la loi n°78-17 du 6 janvier 1978 (dite « Loi informatique et libertés » ou « LIL ») et
                      au Règlement Général sur la protection des Données Personnelles (« RGDP ») n°2016/679 nous vous
                      détaillons notre politique de gestion des données personnelles.<br />
                      En tout état de cause polyglow.fr ne collecte des informations personnelles relatives à l&#39;Utilisateur
                      que pour le besoin de certains services proposés par le site polyglow.fr. L&#39;Utilisateur fournit ces
                      informations en toute connaissance de cause, notamment lorsqu&#39;il procède par lui-même à leur
                      saisie. Il est alors précisé à l&#39;Utilisateur du site polyglow.fr l’obligation ou non de fournir ces
                      informations.<br />
                      Aucune information personnelle de l&#39;Utilisateur du site polyglow.fr n&#39;est publiée à l&#39;insu de
                      l&#39;Utilisateur, échangée, transférée, cédée ou vendue sur un support quelconque à des tiers.<br />
                      Seule l&#39;hypothèse du rachat d’polyglow et de ses droits permettrait la transmission des dites
                      informations à l&#39;éventuel acquéreur qui serait à son tour tenu de la même obligation de conservation
                      et de modification des données vis à vis de l&#39;Utilisateur du site polyglow.fr.</p>

                      <h5>Utilisation du courrier électronique</h5>
                      <p>Si vous souhaitez utiliser le formulaire de contact, vous êtes informé(e) que le secret des
                      correspondances transmises sur le réseau Internet n&#39;est pas garanti.</p>

                      <h5>Droit applicable et attribution de juridiction</h5>
                      <p>Tout litige en relation avec l’utilisation du site polyglow.fr est soumis au droit français. Il est fait
                      attribution exclusive de juridiction aux tribunaux compétents de Nanterre.</p>

                      <h5>Collecte et traitement des données personnelles</h5>
                      <p>Le Site assure à l’Utilisateur une collecte et un traitement d’informations personnelles dans le
                      respect de la vie privée, conformément à la loi n°78-17 du 6 janvier 1978 relative à l’informatique,
                      aux fichiers et aux libertés, et au Règlement UE 2016/679 relatif à la protection des données (RGPD).<br />
                      L’Utilisateur qui visite le site a polyglow.fr demeure, par principe, anonyme.<br />
                      Les informations techniques collectées au cours de sa navigation servent à analyser son
                      comportement sur le Site, et l’usage qu’il en a, afin de pouvoir améliorer son expérience
                      d’Utilisateur.<br />
                      Peuvent ainsi être recueillies : l’URL des liens par l’intermédiaire desquels l’Utilisateur a accédé au
                      Site, le fournisseur d’accès de l’Utilisateur, l’adresse de protocole Internet (IP) de l’Utilisateur.<br />
                      L’ensemble des données techniques sont collectées et traitées uniquement pour les finalités
                      suivantes :<br />
                      • Accès, utilisation et amélioration de la navigation sur le Site ;<br />
                      • Lutte contre la fraude informatique (spamming, hacking…) ;<br />
                      • Favoriser la prise de contact commerciale ;<br />
                      • Mener des campagnes de communication (mailing) ;<br />
                      • Envoyer des supports d’information.<br />

                      Lorsque certaines informations personnelles sont obligatoires pour accéder à des fonctionnalités
                      spécifiques du Site, ce caractère obligatoire est indiqué au moment de la saisie des données.<br />
                      En cas de refus de l’Utilisateur de fournir ces informations, il n’aura pas accès à certains services,
                      fonctionnalités ou rubriques du Site.<br />
                      Les données personnelles de l’Utilisateur ne sont collectées que s’il accepte de les fournir dans le
                      cadre de l’utilisation des fonctionnalités suivantes du Site :</p>

                      <h5>Formulaire de contact :</h5>
                      <p>Le traitement des données collectées dans le cadre du remplissage dU formulaire de contact a pour
                      finalité :<br />
                      • La gestion de la relation avec les prospects sollicitant d’être recontactés ;<br />
                      • L’organisation d’opérations promotionnelles et/ou d’information.</p>

                      <h5>Transmission de données</h5>
                      <p>L’Utilisateur est informé que certaines données personnelles collectées peuvent faire l’objet d’une
                      transmission aux partenaires techniques d’polyglow.</p>

                      <h5>Conservation des données</h5>
                      <p>Les données personnelles sont conservées sur un serveur sécurisé pendant une durée de 5 ans et
                      uniquement pour répondre aux finalités pour lesquelles elles sont collectées et traitées.</p>

                      <h5>Confidentialité</h5>
                      <p>Des mesures de sécurité appropriées sont mises en œuvre par polyglow pour garantir la
                      confidentialité des données de l’Utilisateur, et notamment éviter tout accès à celles-ci par des tiers
                      non autorisés.<br />
                      L’accès aux données personnelles de l’Utilisateur est strictement limité à polyglow et à ses
                      employés, habilités en raison de leurs fonctions, et eux-mêmes tenus à une obligation de
                      confidentialité.<br />
                      Cependant, les données collectées pourront, sans autorisation préalable de l’Utilisateur, être
                      éventuellement communiquées à des tiers prestataires chargés, notamment, de l’exécution de
                      tâches nécessaires au bon fonctionnement du Site et de ses services. Dans le cadre de cette
                      exécution, ces prestataires seront eux-mêmes contractuellement tenus à la confidentialité.<br />
                      Enfin, en cas de rachat du Site et de ses droits, l’ensemble des données collectées afférentes seront
                      de plein droit transmises à l’acquéreur qui sera alors tenu, à son tour, de la même obligation de
                      conservation et de confidentialité des données vis-à-vis de l’Utilisateur du Site.</p>

                      <h5>Droits de l’Utilisateur sur ses données</h5>
                      <p>Conformément à l&#39;art.34 de la loi &quot;Informatiques et libertés&quot; ( www.cnil.fr ) , vous disposez d&#39;un droit
                      d&#39;accès, de modification, de rectification et de suppression des données qui vous concernent.<br />
                      Pour toute demande (mise à jour, modification ou suppression, etc.) concernant ses données
                      personnelles, l’Utilisateur peut contacter polyglow par e-mail à l’adresse suivante :
                      info@polyglow.fr.<br />
                      Pour des raisons de sécurité, et afin d’éviter toute demande frauduleuse, en effectuant votre
                      demande écrite et signée, nous vous demanderons de l’accompagner d’une copie de votre titre
                      d’identité avec signature du titulaire de la pièce, en précisant l’adresse à laquelle la réponse doit être
                      envoyée. Ce justificatif sera détruit une fois la demande traitée.ca<br />
                      En cas de difficultés concernant la gestion de vos données personnelles, celui-ci peut contacter la
                      Commission Nationale de l’informatique et des Libertés (www.cnil.fr)</p>

                      <h5>Responsable du traitement des données personnelles</h5>
                      <p>La personne responsable du traitement des données personnelles est France-Anne Chenu-Tournier
                      Présidente de polyglow.<br />
                      Elle peut être contacté par simple mail à l’adresse suivante : info@polyglow.fr</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}